import { render } from "./CartRemoveItem.vue?vue&type=template&id=92887d64"
import script from "./CartRemoveItem.vue?vue&type=script&lang=js"
export * from "./CartRemoveItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__